define([
	'internal_util/Util',
	'internal_util/Base64Util',
	'model/bindings/PasswordBindingType',
	'model/bindings/WebCryptoKeyBindingType',
	'model/bindings/FidoWebAuthnBindingType'
], function (
		Util,
		Base64Util,
		PasswordBindingType,
		WebCryptoKeyBindingType,
		FidoWebAuthnBindingType
		) {
	'use strict';

	/**
	 * BindingsFactory class
	 */
	return new function () {
		//TODO: logging
		this.createPasswordBinding = function (secret, salt) {
			return new PasswordBindingType(secret,salt);
		};
		
		this.createWebCryptoKeyBindingType = function (secret, salt, keyId) {
			return new WebCryptoKeyBindingType(secret, salt, keyId);
		};
		
		this.createFidoWebAuthn = function (newCredentialInfo, appId, credentialId, nonce, pvr, salt) {
			const attestation = newCredentialInfo.response.attestationObject;
			const clientData = newCredentialInfo.response.clientDataJSON;
			return new FidoWebAuthnBindingType(attestation, clientData, appId, credentialId, nonce, pvr, salt);
		};

		this.createFromObject = function (bindings) {
			if (!Util.isArray(bindings)) {
				var tmp =  bindings;
				bindings = new Array();
				bindings.push(tmp);
			}

			var bindingTypes = new Array();
			
			for (var b in bindings) {
				switch(bindings[b]["type"]) {
					case "http://ws.skidentity.de/ci/binding/password/v1.0":
						bindingTypes.push(new PasswordBindingType(bindings[b]["secret"] ? bindings[b]["secret"] : null, 
								bindings[b]["salt"]));
						break;
					case "http://ws.skidentity.de/ci/binding/key/v1.0":
						switch(bindings[b]["origin"]) {
							case "WebCrypto":
								bindingTypes.push(new WebCryptoKeyBindingType(bindings[b]["secret"] ? bindings[b]["secret"] : null, 
										bindings[b]["salt"], bindings[b]["keyId"]));
								break;
							case "FIDO/WebAuthn":
								const credentialId = Base64Util.decodeBase64Url(bindings[b]["credentialId"]);
								const salt = bindings[b]["salt"];
	
								bindingTypes.push(new FidoWebAuthnBindingType(null, null, null, credentialId, null, null, salt));
								break;
						}
						break;
				}
			}

			return bindingTypes;
		};
		
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/factory/BindingsFactory.js
// module id = 43
// module chunks = 8